// Default colors for 3D SCENE content (lights, backdrop, ground) — not UI chrome.
//
// These are deliberately hex literals and deliberately NOT --m-* tokens: they
// are handed to three.js (THREE.Color / light color props), which cannot read a
// CSS custom property, and they describe the rendered world rather than the
// editor's surfaces. The palette a user picks themes the app; it must not
// silently retint the lighting rig or the backdrop of a render.
//
// Keeping them in one module (instead of inline in liveTuneStore's DEFAULTS)
// gives the palette-enforcement lock (tests/unit/paletteEnforcement.test.mjs)
// one functional home to allowlist, so adding a sibling scene color doesn't
// require raising a ratchet on a file full of UI code.

// Neutral white — lights are tinted by their own intensity/temperature knobs.
export const SCENE_WHITE = '#ffffff'

// HemisphereLight's downward (ground-bounce) term: a dim neutral grey.
export const HEMI_GROUND = '#444444'

// Backdrop sky. Matches the --m-bg-graph default (#141414) so switching the
// backdrop ON with untouched colors looks like the themed canvas it replaces.
export const BACKDROP_SKY = '#141414'

// Backdrop ground plane: mid-dark neutral, reads as a studio floor under the
// avatar without competing with her for value.
export const BACKDROP_GROUND = '#3a3a3a'

// The ?hairtest=1 scene (HairTestApp.jsx): a fixed three-point rig judged
// against Unreal renders, so its colours are part of the measurement and must
// not follow the app palette either.
export const HAIR_TEST_BACKDROP = '#1c1c1c'     // fixed dark backdrop, not the app theme
export const HAIR_TEST_SCALP = '#0b0806'        // unlit stand-in head under the wig
export const HAIR_TEST_KEY = '#fff4e6'          // warm key
export const HAIR_TEST_BACK = '#dfe8ff'         // cool rim
export const HAIR_TEST_SKY = '#cfdcff'          // hemisphere sky
export const HAIR_TEST_GROUND_BOUNCE = '#3a2a1c' // hemisphere ground (warm floor bounce)
